<template>
    <div>
        <SearchList v-model="params" :queryConfig="queryConfig" @query="getList" :isAdd="true"
            @add="add"></SearchList>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" lazy>

            <el-tab-pane v-for="tab in tabs" lazy :key="tab.name" :label="tab.label"
                :name="tab.name">
                <div class="table_wrap">
                    <vxe-table class="my_table" ref="my_table" :key="tableKey" :data="rows" border
                        show-header-overflow show-overflow highlight-hover-row height="auto"
                        auto-resize stripe round resizable :loading="loading"
                        :checkbox-config="checkboxConfig" :radio-config="radioConfig"
                        header-row-class-name="my_head" :show-footer="JSON.stringify(footer)!='{}'"
                        @cell-dblclick="dblRowHandle">
                        <vxe-table-column width="50" v-if="!tableConfig.singleselect"
                            type="checkbox" field="my_check" align="center"></vxe-table-column>
                        <vxe-table-column width="50" v-if="tableConfig.singleselect" type="radio"
                            field="my_check" align="center"></vxe-table-column>
                        <vxe-table-column align="center" type="seq" title="序号" width="60"
                            field="index">
                        </vxe-table-column>
                        <vxe-table-column v-if="!item.hidden"
                            v-for="(item, index) in tableConfig.listConfig" :key="index"
                            :field="item.zdname" :title="item.label"
                            :align="tableConfig.align?tableConfig.align:'center'"
                            :width="item.width||null" :sortable="!item.tableButtonList"
                            :fixed="item.fixed?'right':null">
                            <template #default="{ row ,rowIndex }">
                                <div v-if="item.formatFunc">
                                    <div v-html="formatFunc(row,item.zdname,item.formatFunc)"></div>
                                </div>
                                <div v-if="!item.formatFunc">
                                    <div v-if="!item.format">{{row[item.zdname]}}</div>
                                    <div v-if="item.format">{{item.format(row[item.zdname])}}</div>
                                </div>
                                <div v-if="item.tableButtonList">
                                    <el-button class="my_btn"
                                        v-for="(item2, index2) in item.tableButtonList"
                                        :key="index2" status="primary" size="mini"
                                        v-if="formatTableBtn(item2,row)" :content="item2.name"
                                        type="primary" plain
                                        @click.stop="handleTablebtnClick(row,item2['func'])">
                                        {{item2.name}}</el-button>
                                </div>
                            </template>
                        </vxe-table-column>

                        <slot></slot>

                    </vxe-table>
                </div>
                <div class="footer_wrap" v-if="tableConfig.page!==false">
                    <vxe-pager perfect :current-page.sync="pageIndex" :page-size.sync="pageSize"
                        :loading="loading" :total="total" :page-sizes="[20, 50, 100,1000]"
                        :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                        @page-change="pageChange">
                        <template #left>
                            <vxe-button size="small" @click="getData">
                                <template #default>
                                    <i
                                        :class="{'el-icon-refresh':!loading,'el-icon-loading':loading}"></i>
                                </template>
                            </vxe-button>
                        </template>
                    </vxe-pager>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
  name: "comTabs",
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    queryConfig: {
      type: Array,
      default: () => []
    },
    tableConfig: {
      type: Object,
      required: true,
      default: {}
    },
  },
  created() {
    if (this.tabs.length) {
      this.activeName = this.tabs[0].name;
    }
  },
  data() {
    return {
      activeName: ""
    }
  }
}
</script>
